/**
 * Create a link and downlaod a blob.
 * @param {blob} data - An api responseType: blob
 * @param {string} type - The mime_type of the blob.
 * @param {string} filename - The filename of the download.
 */

if (!HTMLCanvasElement.prototype.toBlob) {
    Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
      value: function (callback, type, quality) {
        var canvas = this;
        setTimeout(function() {
          var binStr = atob( canvas.toDataURL(type, quality).split(',')[1] ),
          len = binStr.length,
          arr = new Uint8Array(len);

          for (var i = 0; i < len; i++ ) {
             arr[i] = binStr.charCodeAt(i);
          }

          callback( new Blob( [arr], {type: type || 'image/png'} ) );
        });
      }
   });
 }

export const downloadBlob = (data, type, filename) => {
    const link = document.createElement('a');
    const blob = new Blob([data], { type });
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.click();
};
